import React from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { Organization } from "../../../../../application/domain/organization/organization";
import { reportUnexpectedError } from "../../../../../error-reporter";
import { KintoneExportSettingCreateContent } from "../../../../organisms/kintone-export/kintone-export-setting-create-content/kintone-export-setting-create-content";
import { ServiceProviderTemplate } from "../../../../template/service-provider/default-template";
import { useKintoneExportCreatePage } from "../../../data-transfer/kintone-export/page-hooks/kintone-export-setting-create/hook";
import { ServiceProviderR } from "../../routes";
import { KintoneExportOrgProductAssertion } from "./plugin/kintone-export-org-product-assertion-plugin";
import apiClient from "../../../../../application/apis/api-client";

export const KintoneExportSettingCreatePage: React.FC = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const [tenant, setTenant] = React.useState<Organization>();
  React.useEffect(() => {
    apiClient
      .getOrganization(tenantId)
      .then(({ data }) => {
        setTenant(data);
      })
      .catch((e) => {
        toast.error("テナント情報の取得に失敗しました。");
        reportUnexpectedError(e);
      });
  }, [tenantId, setTenant]);

  const {
    input,
    setInput,
    selectedSmartApplyProcedure,
    kintoneAppUrl,
    isLoading,
    showDialog,
    showValidationErrorMessage,
    showKintoneApiErrorMessage,
    showNoEmailUserInGroupErrorMessage,
    onClickCreateOnPage,
    onClickCreateOnDialog,
    onClickCancelOnDialog,
  } = useKintoneExportCreatePage({
    tenantId,
    detailLinkProvider: ServiceProviderR.KintoneExportSettingDetail.link,
  });

  return (
    <>
      <KintoneExportOrgProductAssertion />
      <ServiceProviderTemplate
        breadcrumbs={[
          {
            to: ServiceProviderR.Home.link({}),
            title: "Home",
          },
          {
            to: ServiceProviderR.DataTransferTop.link({ tenantId }),
            title: "データ連携",
          },
          {
            to: ServiceProviderR.KintoneExportSettings.link({ tenantId }),
            title: "スマート申請の申請データを kintone へ転送",
          },
          {
            to: ServiceProviderR.KintoneExportSettingCreate.link({ tenantId }),
            title: "新規作成",
          },
        ]}
      >
        <KintoneExportSettingCreateContent
          tenant={tenant}
          selectedProcedure={selectedSmartApplyProcedure}
          kintoneAppUrl={kintoneAppUrl}
          isLoading={isLoading}
          showDialog={showDialog}
          showValidationErrorMessage={showValidationErrorMessage}
          showKintoneApiErrorMessage={showKintoneApiErrorMessage}
          showNoEmailUserInGroupErrorMessage={
            showNoEmailUserInGroupErrorMessage
          }
          onClickCreateOnPage={onClickCreateOnPage}
          onClickCreateOnDialog={onClickCreateOnDialog}
          onClickCancelOnDialog={onClickCancelOnDialog}
          createKintoneExportSettingInput={input}
          onChange={setInput}
        />
      </ServiceProviderTemplate>
    </>
  );
};
